import React, { useState } from "react";
import { Select, Input, Table, Button, Card } from "antd";
import { SearchOutlined, EnvironmentOutlined } from "@ant-design/icons";
import _ from "lodash";
import callVenueApi from "../util/venueAPICaller";

const { Option } = Select;

const VenueSearchComponent = ({
  cities,
  onSelectVenueChange,
  header,
}) => {
  const [selectedCity, setSelectedCity] = useState("");
  const [venueList, setVenueList] = useState([]);

  const handleCityChange = (value) => {
    setSelectedCity(value);
  };

  const handleSearchChange = async (e) => {
    await searchForCity(selectedCity, _.kebabCase(e.target.value));
  };

  const searchForCity = async (city, text) => {
    if (!city || !text) {
      setVenueList([]);
      return;
    }

    let res = await callVenueApi(
      `api/searchbox/venue?city=${city}&term=${text}`,
      "get"
    );

    if (res && res.status === "Success") {
      if (res.data.venues) {
        setVenueList(res.data.venues);
      }
    } else {
      console.log("Search item failed", res);
    }
  };

  const handleSelectVenue = (venue) => {
    onSelectVenueChange(venue);
  };

  const columns = [
    {
      title: "Venue Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <span
            style={{
              fontWeight: 600,
              color: "#2d3748",
              fontSize: "14px",
            }}
          >
            {record.name}
          </span>

          <span
            style={{
              fontSize: "12px",
              color: "#718096",
              marginTop: "2px",
            }}
          >
            <EnvironmentOutlined /> {record.city}
          </span>
        </div>
      ),
    },
    {
      title: "Action",
      key: "select",
      width: 180,
      render: (text, record) => (
        <Button
          type="primary"
          onClick={() => handleSelectVenue(record)}
          style={{
            borderRadius: "8px",
            fontWeight: 500,
            height: "36px",
            padding: "0px 18px",
            background:
              "linear-gradient(135deg, #6b46c1 0%, #805ad5 100%)",
            border: "none",
            boxShadow: "0 4px 10px rgba(107, 70, 193, 0.25)",
          }}
        >
          Select Venue
        </Button>
      ),
    },
  ];

  return (
    <div
      style={{
        padding: "20px",
      }}
    >
      <Card
        style={{
          borderRadius: "16px",
          border: "1px solid #ececec",
          boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
        }}
        bodyStyle={{
          padding: "24px",
        }}
      >
        {/* Header */}
        <div
          style={{
            marginBottom: "24px",
            textAlign: "center",
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: "22px",
              fontWeight: 700,
              color: "#2d3748",
            }}
          >
            Search Venue
          </h2>

          <p
            style={{
              marginTop: "6px",
              color: "#718096",
              fontSize: "13px",
            }}
          >
            Search and update venue details quickly
          </p>
        </div>

        {/* Search Box */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "14px",
            flexWrap: "wrap",
            marginBottom: "20px",
          }}
        >
          <Select
            style={{
              width: "180px",
            }}
            placeholder="Select City"
            size="large"
            onChange={handleCityChange}
          >
            {cities.map((item) => (
              <Option key={item._id} value={item.name}>
                {_.startCase(item.label)}
              </Option>
            ))}
          </Select>

          <Input
            size="large"
            prefix={<SearchOutlined />}
            style={{
              width: "320px",
              borderRadius: "10px",
            }}
            placeholder="Search venue name..."
            onChange={handleSearchChange}
          />
        </div>

        {/* Table */}
        {venueList && venueList.length > 0 ? (
          <Table
            dataSource={venueList}
            columns={columns}
            rowKey="_id"
            pagination={false}
            scroll={{ y: 420 }}
            style={{
              marginTop: "10px",
            }}
          />
        ) : (
          <div
            style={{
              textAlign: "center",
              padding: "50px 20px",
              color: "#a0aec0",
              fontSize: "14px",
            }}
          >
            Search venues by selecting a city and typing a venue name
          </div>
        )}
      </Card>
    </div>
  );
};

export default VenueSearchComponent;